import React from 'react';
import { cva } from 'class-variance-authority';
import { cn } from '../../utils/cn';

const meetingCardVariants = cva(
  "bg-white rounded-xl border border-gray-200 p-4 hover:shadow-lg transition-shadow duration-200"
);

export const MeetingCard = React.forwardRef(({
  className,
  title,
  description,
  startTime,
  endTime,
  date,
  attendees = [],
  additionalAttendees = 0,
  icon = "fa-solid fa-video",
  ...props
}, ref) => {
  return (
    <div
      ref={ref}
      className={cn(meetingCardVariants(), className)}
      {...props}
    >
      {/* Header */}
      <div className="flex items-center justify-between mb-3">
        <div className="flex items-center space-x-2">
          <i className={cn(icon, "text-blue-600")} />
          <span className="text-sm font-medium text-gray-900">Meeting</span>
        </div>
        <button className="p-1 text-gray-400 hover:text-gray-600">
          <i className="fa-solid fa-ellipsis" />
        </button>
      </div>

      {/* Content */}
      <div className="mb-4">
        <h3 className="text-sm font-semibold text-gray-900 mb-2">
          {title}
        </h3>
        <p className="text-xs text-gray-600 leading-relaxed mb-3">
          {description}
        </p>
        
        {/* Time */}
        <div className="flex items-center space-x-2 text-xs text-gray-600">
          <i className="fa-solid fa-clock" />
          <span>{date}, {startTime} - {endTime}</span>
        </div>
      </div>

      {/* Attendees */}
      <div className="flex items-center space-x-2">
        <div className="flex -space-x-1">
          {attendees.slice(0, 3).map((attendee, index) => (
            <div key={index} className="relative">
              {attendee.avatar ? (
                <img
                  src={attendee.avatar}
                  alt={attendee.name}
                  className="w-6 h-6 rounded-full border-2 border-white"
                />
              ) : (
                <div className="w-6 h-6 rounded-full bg-gray-300 border-2 border-white flex items-center justify-center">
                  <span className="text-xs font-medium text-gray-600">
                    {attendee.name?.charAt(0) || '?'}
                  </span>
                </div>
              )}
            </div>
          ))}
          {additionalAttendees > 0 && (
            <div className="w-6 h-6 rounded-full bg-gray-200 border-2 border-white flex items-center justify-center">
              <span className="text-xs font-medium text-gray-600">
                +{additionalAttendees}
              </span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
});

MeetingCard.displayName = "MeetingCard"; 